import { SENTRY_DSN } from '@/config/constants';

export const isSentryConfigured = () => {
  return !!SENTRY_DSN;
};
